import { Component, inject, Inject, TemplateRef } from '@angular/core';
import { NzModalRef, NZ_MODAL_DATA,NzModalService } from 'ng-zorro-antd/modal';
import { OutsourcingRequestVendorModel, OutsourcingRequestVendorResponseModel, VendorModel } from '../../../models/vendor.model';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { EventViewModel } from '../../../models-views/event.view.model';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { VendorDrawerComponent } from '../../vendor-drawer/vendor-drawer.component';
import { QuickAddService } from '../../../services/quick-add.service';
import { VendorViewModel } from '../../../models-views/vendor.view.model';
import { AppCommon } from '../../../providers/app-common';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-cet-vendor-details',
  standalone: false,
  templateUrl: './cet-vendor-details.component.html',
  styleUrl: './cet-vendor-details.component.scss'
})
export class CetVendorDetailsComponent {
  modalData:any
  data:any
  editPocData:any
  isVisibleAddPoc:boolean = false
  outsourcingRequestVendorDetailModel = new BehaviorSubject<VendorModel>(new VendorModel());
  private destroy$ = new Subject<boolean>();
  loggedInUser: any;

  constructor(
    private modalRef: NzModalRef,
    private vm: EventViewModel,
    private vmv: VendorViewModel,
    private drawerService: NzDrawerService,
    private quickAddService: QuickAddService,
    private modal: NzModalService,
    private message: NzMessageService
  ) {
    this.vm.cetVendorDetailsComponent = this
    this.vmv.cetVendorDetailsComponent = this
    this.modalData = inject(NZ_MODAL_DATA)

    this.vm.subscribeToRFQDetails(this.outsourcingRequestVendorDetailModel);
    this.modalData.id && this.vm.getOutsourcingRequestVendorDetails(this.modalData.id)
    this.quickAddService.refreshData.pipe(takeUntil(this.destroy$)).subscribe(data => {
         if (data) {
           vm.getOutsourcingRequestVendorDetails(this.modalData.id)
        }
    })
    this.loggedInUser = AppCommon.getloggedInObject().user;
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'PENDING':
        return 'default';
      case 'VIEWED':
        return 'processing';
      case 'DRAFTING':
        return 'warning';
      case 'SUBMITTED':
        return 'success';
      case 'DECLINED':
        return 'error';
      default:
        return 'default';
    }
 }

ngOnDestroy(): void {
  //Called once, before the instance is destroyed.
  //Add 'implements OnDestroy' to the class.
  this.destroy$.next(true);
  this.destroy$.complete();
}
  drawerRef?: NzDrawerRef;

editVendorDrawer(footerTemplate: TemplateRef<void>): void {
    this.drawerRef = this.drawerService.create({
      nzTitle: 'Edit Vendor',
      nzContent: VendorDrawerComponent,
      nzWidth: '50vw',
      nzClosable: true,
      nzData: {
        vendor: this.data,
      },
      nzFooter: footerTemplate as unknown as TemplateRef<{}>
    });

    this.drawerRef.afterClose.subscribe(result => {
      if (result !== undefined) {
        console.log('Drawer closed with result:', result);
      } else {
        console.log('Drawer dismissed');
      }
    });
  }


  deleteVendor() {
    this.vmv.deleteVendor(this.modalData)
  }
  vendorDeletd(){
    this.modalRef.close(true);
  }

  close(): void {
    this.modalRef.destroy();
  }

  outsourcingRequestVendorDetailsRecieved(){
    this.data = this.outsourcingRequestVendorDetailModel.value;
      if (this.modalData.id && this.data) {
      this.vmv.fetchVendorTax(this.modalData.id, (taxData: any) => {
      this.data['tax_type_name'] = taxData.tax_type_name;
      this.data['tax_input'] = taxData.tax_input;
      });
    }
  }


  closeAddPocEvent(poc: any) {
    console.log(poc)
    this.isVisibleAddPoc = false;
  }

  closeAddPoc(poc:any){
      console.log(poc)
  }


  editPOC(poc: any) {
    this.editPocData = poc
    this.isVisibleAddPoc = true;
  }


  pocDeleted() {
    this.quickAddService.refreshData.next(true)
  }

  handleDelete(poc: any) {
    if (!poc.is_primary) {
       this.deletePOC(poc);
    }
  }

  deletePOC(poc: any) {
    this.vmv.deletePOC(poc.id);
  }

  setPrimaryPOCDetail(poc: any) {
    const modalRef = this.modal.confirm({
        nzTitle: `Are you sure you want to make primary "${poc.contact_person}"?`,
        // nzContent:
        //   '<b style="color: red;">If you make this, you will no longer be able to restore it.</b>',
        nzOkText: 'Yes',
        nzOkType: 'primary',
        nzOkDanger: true,
        nzOnOk: () => {
          const payload = {
            id: poc.id,
            contact_person: poc.contact_person,
            email: poc.email,
            phone_number: poc.phone_number,
            designation: poc.designation,
            linkedin: poc.linkedin,
            is_primary: true, // Set primary
            created_by: poc.created_by,
            modified_by: this.loggedInUser.id,
            vendor: poc.vendor,
            country_code: poc.country_code,
          };

          this.vmv.updatePOC(payload, poc.id, 'vendorDetailComponent', (tempData: any) => {
            modalRef.destroy();

            // REFRESH FULL MODAL DATA
            if (this.modalData.id) {
              this.vm.getOutsourcingRequestVendorDetails(this.modalData.id); // fetch latest vendor data
              this.vmv.fetchVendorTax(this.modalData.id, (taxData: any) => {
                this.data['tax_type_name'] = taxData.tax_type_name;
                this.data['tax_input'] = taxData.tax_input;
              });
            }

            this.message.success(`"${tempData.contact_person}" is now set as primary`, { nzDuration: 1500 });
          });
        },
        nzCancelText: 'No',
    });
  }




}
